// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueDatetime.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueDatetime component
 */
!(function() {
  var m = require('mobx-react');
  var React = require('react');

  var OperatorValueOneDatePicker = require('modules/OperatorValue/Izenda.OperatorValueOneDatePicker');
  var OperatorValueTwoDatePicker = require('modules/OperatorValue/Izenda.OperatorValueTwoDatePicker');
  var OperatorValueInput = require('modules/OperatorValue/Izenda.OperatorValueInput');
  var OperatorValueDropdownGroup = require('modules/OperatorValue/Izenda.OperatorValueDropdownGroup');
  const { isNil, placeholder } = require('lodash/fp');

  /**
   * Get component render function
   * @param  {object} object Component object
   * @param  {string} key Operator filter key
   * @return {function} Render component function
   */
  function getComponentRender(object, key) {
    return placeholder(object).get(key);
  }

  /**
   * Datetime filter value
   * @type {Object}
   */
  var dateTimeFilterComponents = {
    'equals(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'equals(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'equals(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'notequal(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'notequal(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'notequal(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'between(date)': {
      component: OperatorValueTwoDatePicker,
      props: {
        time: false
      }
    },
    'between(date&time)': {
      component: OperatorValueTwoDatePicker
    },
    'between(time)': {
      component: OperatorValueTwoDatePicker,
      props: {
        calendar: false
      }
    },
    'notbetween(date)': {
      component: OperatorValueTwoDatePicker,
      props: {
        time: false
      }
    },
    'notbetween(date&time)': {
      component: OperatorValueTwoDatePicker
    },
    'notbetween(time)': {
      component: OperatorValueTwoDatePicker,
      props: {
        calendar: false
      }
    },
    intimeperiod: {
      component: OperatorValueDropdownGroup,
      props: {
        labelField: 'name',
        valueField: 'id',
        groupBy: 'type'
      }
    },
    lessthandaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    equalsdaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    greaterthandaysold: {
      component: OperatorValueInput,
      props: {
        isNumberInput: true
      }
    },
    'islessthan(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'islessthan(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'islessthan(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    },
    'isgreaterthan(date)': {
      component: OperatorValueOneDatePicker,
      props: {
        time: false
      }
    },
    'isgreaterthan(date&time)': {
      component: OperatorValueOneDatePicker
    },
    'isgreaterthan(time)': {
      component: OperatorValueOneDatePicker,
      props: {
        calendar: false
      }
    }
  };

  /**
   * [FilterValueDatetime description]
   * @param {[type]} props [description]
   */
  var OperatorValueDatetime = function(props) {
    var filterSource = this.props.filterSource;
    var filterInfo = this.props.filterInfo;
    var operator = filterInfo.operator || {};

    var key = operator.key;
    var componentInfo = getComponentRender(dateTimeFilterComponents, key);

    if (isNil(componentInfo)) {
      return null;
    }

    return <componentInfo.component {...componentInfo.props} {...props} />;
  };

  module.exports = m.observer(OperatorValueDatetime);
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueDatetime.jsx